module.exports = __webpack_public_path__ + "static/media/student_musician.09413fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/student_musician.jpg
// module id = 769
// module chunks = 0